/*throttle/debounce*/(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);
/*browser_selector*/function css_browser_selector(u){var ua=u.toLowerCase(),is=function(t){return ua.indexOf(t)>-1},g='gecko',w='webkit',s='safari',o='opera',m='mobile',h=document.documentElement,b=[(!(/opera|webtv/i.test(ua))&&/msie\s(\d)/.test(ua))?('ie ie'+RegExp.$1):is('firefox/2')?g+' ff2':is('firefox/3.5')?g+' ff3 ff3_5':is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')?g+' ff3':is('gecko/')?g:is('opera')?o+(/version\/(\d+)/.test(ua)?' '+o+RegExp.$1:(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')):is('konqueror')?'konqueror':is('blackberry')?m+' blackberry':is('android')?m+' android':is('chrome')?w+' chrome':is('iron')?w+' iron':is('applewebkit/')?w+' '+s+(/version\/(\d+)/.test(ua)?' '+s+RegExp.$1:''):is('mozilla/')?g:'',is('j2me')?m+' j2me':is('iphone')?m+' iphone':is('ipod')?m+' ipod':is('ipad')?m+' ipad':is('mac')?'mac':is('darwin')?'mac':is('webtv')?'webtv':is('win')?'win'+(is('windows nt 6.0')?' vista':''):is('freebsd')?'freebsd':(is('x11')||is('linux'))?'linux':'','js']; c = b.join(' '); h.className += ' '+c; return c;};
/*cookie_script*/!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){function c(a){return h.raw?a:encodeURIComponent(a)}function d(a){return h.raw?a:decodeURIComponent(a)}function e(a){return c(h.json?JSON.stringify(a):String(a))}function f(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(b," ")),h.json?JSON.parse(a):a}catch(a){}}function g(b,c){var d=h.raw?b:f(b);return a.isFunction(c)?c(d):d}var b=/\+/g,h=a.cookie=function(b,f,i){if(arguments.length>1&&!a.isFunction(f)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setMilliseconds(k.getMilliseconds()+864e5*j)}return document.cookie=[c(b),"=",e(f),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=b?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;n<o;n++){var p=m[n].split("="),q=d(p.shift()),r=p.join("=");if(b===q){l=g(r,f);break}b||void 0===(r=g(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b)}});


var breakpoints = {
        xs: 480,
        sm: 768,
        md: 992,
        lg: 1200
    };

function scrollAnchor(){
    var url = $(location).attr('href').split("#")[0];

    if (($(this).attr('href') === undefined) || !$(this).attr('href').match('^('+url+')?\#.+$')) {
        return true;
    } else {
        var id = $(this).attr('href').replace(url, '');
        if ($(id).length)
            scrTo(id, 500, 0);
        return false;
    }
}

$(document).on('click', 'a', scrollAnchor);

function scrTo(id, speed, mOffset){
    $('html,body').stop().animate({scrollTop: $(id).offset().top - (mOffset+5)}, speed, function() {}); //+5 je kuli firefoxu, kterej neumi jezdit spravne na kotvicky
}

function confirmHandler() {
    if ($(this).data("confirm")) {
        return confirm($(this).data("confirm"));
    } else {
        console.log('Missing data-confirm');
        return true;
    }
}

//Mobile check
function isMobile() {
    var rtn;
    $( window ).outerWidth() < breakpoints.md ? rtn = true : rtn = false;
    return rtn;
}

function isSmallMobile() {
    var rtn;
    $( window ).outerWidth() < breakpoints.sm  ? rtn = true : rtn = false;
    return rtn;
}

$.fn.ajax = function(target, post, result) {
    if (target) {
        $.ajax({ url: target, data: post }).done(function(data) {
            $(result).replaceWith(data);
        });
    }
};

$(document).on("click", "a.ajax", function(e) {
    e.preventDefault();
    redrawContent($(this).attr('href'));
    return false;
});

$(document).on("submit", "form.ajax", function(e) {
    e.preventDefault();
    var data = $(this).serializeArray();
    redrawContent($(this).attr('action'), data);
    return false;
});

$(document).on("click", ".confirm", confirmHandler);

var smloader = '<div class="smloading" style="' +
    'position: absolute;' +
    'left: 0;' +
    'top: 0;' +

    'background-color: white;' +
    'background-image: url(/media/icons/loader.gif);' +
    'background-repeat: no-repeat;' +
    'background-position: center;' +

    'height: 100%;' +
    'width: 100%;' +
    'z-index: 999;' +
    'opacity: 0.5;' +
    'display: flex;' +
    'align-items: center;' +
    'justify-content: center;"></div>';

function redrawContent(url, data, callback, targets) {
    if (url) {
        if ((typeof showLoader === "function") && !targets)
            showLoader();

        var timeout = setTimeout(function () {
            $(targets).each(function () {
                if ($(this).css('position') === "static") {
                    $(this).css({position: "relative"});
                }
                $(this).append(smloader) ;
            });
        }, 500);

        $.post(url, data, function (payload) {
            clearTimeout(timeout);
            if (typeof hideLoader === "function")
                hideLoader();

            if (payload.hasOwnProperty('adminpanel-response') && (typeof setResponseFormated === "function")) {
                setResponseFormated(payload['adminpanel-response']);
            }

            for(var contentId in payload) {
                if (payload.hasOwnProperty(contentId) && (contentId !== 'callbackdata')) {
                    var target = $('#'+escapeSelector(contentId));
                    if (target.length) {
                        if ((typeof CKEDITOR !== 'undefined') && CKEDITOR.instances.hasOwnProperty(contentId)) {
                            CKEDITOR.instances[contentId].setData(payload[contentId]);
                        } else {
                            target.html(payload[contentId]);
                        }
                    }
                }
            }

            if (typeof callback === 'function') {
                if (payload.hasOwnProperty('callbackdata')) {
                    callback(payload['callbackdata']);
                } else {
                    callback();
                }

            }

            if (payload.hasOwnProperty('location')) {
                window.location = payload['location'];
            }
        }, 'json').fail(function(e) {
            if (typeof setResponseFormated === "function")
                setResponseFormated( "Error calling " + url );
            console.log( e );
        });
        return true;
    } else {
        return false;
    }
}

function escapeSelector(selector) {
 return selector.replace(/(!|"|#|\$|%|'|\(|\)|\*|\+|,|\.|\/|:|;|\?|@)/g, function($1, $2) { return "\\" + $2; });
}

function showActionNews() {
    var actionnews = $('#actionnews');
    if (($.cookie("actionnews-disabled") !== "true") && (actionnews.length)) {
        actionnews.find('.disable').click(function () {
            disableActionNews()
            return false;
        });
        actionnews.find('.mywowbutton').click(disableActionNews);
        setTimeout(function(){
            var bottom = $('#adminpanel').length ? 50 : 0;
            $('#actionnews').animate({'bottom': bottom}, 'slow', 'swing');
        },3000);
    }
}

function disableActionNews() {
    $.cookie("actionnews-disabled", "true", {path:'/'});
    $('#actionnews').animate({'bottom': "-450"}, 'slow', 'swing');
}

$(function(){

    css_browser_selector(navigator.userAgent);

    $('.mobile-toggle').click(function () {
        $(this).toggleClass('active');
        $('.topnav-wrap ul').toggleClass('active');
        $('.has-children a').data('clicked', false);
        $('html').toggleClass('no-scroll');
    });

    if (typeof $.prototype.niceSelect === 'function') {
        $('select.make-nice').niceSelect();
    }

    if (typeof $.prototype.popover === 'function') {
        $('[data-toggle="popover"]').popover({
            html: true,
            template: '<div class="popover flags" role="tooltip"><div class="arrow"></div><div class="popover-header"></div><div class="popover-body"></div></div>',
        });
    }

    //scroll
    var paralaxItems = $('[data-paralax-x],[data-paralax-y]')
        steves = $('#steves');
    function paralax()
    {
        $.each(paralaxItems, function () {
            var speedX = $(this).data('paralax-x') || 0,
                speedY = $(this).data('paralax-y') || 0,
                scale = $(this).data('scale') || 1,
                itemTop = $(this).offset().top,
                itemHeight = $(this).height();
            if (((itemTop - window.innerHeight) < window.scrollY) && (window.scrollY < (itemTop + itemHeight))) {
                $(this).css('transform','translate3d('+Math.round(window.scrollY * speedX)+'px, '+Math.round(window.scrollY * speedY)+'px, 0) scale('+scale+')');
            }
        });
    }
    $(window).on('scroll', function() {
        window.requestAnimationFrame(paralax);
    });

    if (steves.length) {
        var n = 1;
        setInterval(function () {
            steves.attr('src', '/media/img/faces/steve'+n+'.png');
            n = n % 6 + 1;
        }, 500)
    }

    //instafeed
    if (typeof Instafeed === 'function') {
        var feed = new Instafeed({
            clientId: 'fd22253fb11b494d8c0dbc1a1c59f4d6',
            get: 'user',
            userId: 'self',
            accessToken: '2692655259.fd22253.176f9a26d5d54a1a865df4256b4e1732',
            limit: 8,
            mock: true,
            resolution: 'low_resolution',
            sortBy: 'most-recent',

            success: function(posts) {
                var postsHolder = $('#instafeed');
                $.each(posts.data, function(i) {
                    var a = $('<a>');
                    a.attr('href', this.link);
                    a.attr('title', this.caption.text);
                    a.append($('<img src="'+this.images.low_resolution.url+'">'));
                    postsHolder.append(a);
                });
            },
            error: function(e) {
                console.log(e);
            }
        });
        feed.run();
    }

    if (isMobile()) {
        $('.has-children a').click(function (e) {
            if (!$(this).data('clicked')) {
                e.preventDefault();
                $(this).data('clicked', true)
                return false;
            }
        });

        $('.books-holder').slick({
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 2,
            arrow:true,
            prevArrow:"<button type='button' class='slick-arrow slick-prev'></button>",
            nextArrow:"<button type='button' class='slick-arrow slick-next'></button>",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('.lang-switch').click(function (e) {
            if (!$(this).data('opened')) {
                e.preventDefault()
                $(this).focus()
                $(this).data('opened', 'true')
                return false
            }
        })
    }

    showActionNews();
});
